import { render, staticRenderFns } from "./FullVideo.vue?vue&type=template&id=6162e28c"
import script from "./FullVideo.vue?vue&type=script&lang=ts"
export * from "./FullVideo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports